module.exports = __webpack_public_path__ + "img/arrow-up-down.84265040.png";